
import { SearchIcon } from "lucide-react";

const SearchLoading = () => {
  return (
    <div className="text-center py-12">
      <div className="inline-block animate-pulse">
        <SearchIcon className="h-12 w-12 text-muted-foreground mb-4" />
      </div>
      <p className="text-muted-foreground">Searching...</p>
    </div>
  );
};

export default SearchLoading;
